import React, { useState } from 'react';
import axios from 'axios';
import './TagsManagement.css';

const API = '/api/cms';

const TagsManagement = ({ tags, setTags, token, showMsg }) => {
  const [newTag, setNewTag] = useState({ name: '', displayName: '', color: '#3b82f6', description: '', category: 'general' });
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({});

  const h = { Authorization: `Bearer ${token}` };

  const createTag = async () => {
    if (!newTag.name.trim()) {
      showMsg('⚠️ Укажите имя тега');
      return;
    }
    try {
      const res = await axios.post(`${API}/tags`, newTag, { headers: h });
      setTags([...tags, res.data]);
      setNewTag({ name: '', displayName: '', color: '#3b82f6', description: '', category: 'general' });
      showMsg('✅ Тег создан');
    } catch (e) {
      showMsg(e.response?.data?.message || 'Ошибка создания тега');
    }
  };

  const startEdit = (tag) => {
    setEditingId(tag._id);
    setEditData({ displayName: tag.displayName, color: tag.color, description: tag.description, category: tag.category });
  };

  const saveEdit = async (id) => {
    try {
      const res = await axios.put(`${API}/tags/${id}`, editData, { headers: h });
      setTags(tags.map(t => t._id === id ? res.data : t));
      setEditingId(null);
      showMsg('✅ Тег обновлён');
    } catch (e) {
      showMsg(e.response?.data?.message || 'Ошибка обновления');
    }
  };

  const deleteTag = async (id) => {
    if (!window.confirm('Удалить тег?')) return;
    try {
      await axios.delete(`${API}/tags/${id}`, { headers: h });
      setTags(tags.filter(t => t._id !== id));
      showMsg('✅ Тег удалён');
    } catch (e) {
      showMsg(e.response?.data?.message || 'Ошибка удаления');
    }
  };

  const categories = [
    { value: 'general', label: 'Общие' },
    { value: 'priority', label: 'Приоритеты' },
    { value: 'type', label: 'Типы' },
    { value: 'status', label: 'Статусы' },
    { value: 'custom', label: 'Пользовательские' }
  ];

  return (
    <div className="tags-management">
      <h2>🏷️ Управление тегами</h2>
      
      <div className="create-tag-form">
        <h3>Создать тег</h3>
        <div className="form-row">
          <input 
            type="text" 
            placeholder="Имя (латиница)" 
            value={newTag.name} 
            onChange={e => setNewTag({ ...newTag, name: e.target.value.toLowerCase().replace(/\s+/g, '-') })} 
          />
          <input 
            type="text" 
            placeholder="Отображаемое имя" 
            value={newTag.displayName} 
            onChange={e => setNewTag({ ...newTag, displayName: e.target.value })} 
          />
          <input 
            type="color" 
            value={newTag.color} 
            onChange={e => setNewTag({ ...newTag, color: e.target.value })} 
            className="color-input"
          />
          <select value={newTag.category} onChange={e => setNewTag({ ...newTag, category: e.target.value })}>
            {categories.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
          </select>
          <button className="btn btn-primary" onClick={createTag}>➕ Создать</button>
        </div>
        <input 
          type="text" 
          placeholder="Описание (необязательно)" 
          value={newTag.description} 
          onChange={e => setNewTag({ ...newTag, description: e.target.value })} 
          className="full-width"
        />
      </div>

      <div className="tags-list">
        <h3>Существующие теги ({tags.length})</h3>
        <table className="tags-table">
          <thead>
            <tr>
              <th>Тег</th>
              <th>Имя</th>
              <th>Категория</th>
              <th>Использований</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {tags.map(tag => (
              <tr key={tag._id}>
                <td>
                  <span className="tag-preview" style={{ background: tag.color, color: '#fff' }}>
                    {tag.displayName}
                  </span>
                </td>
                <td>{tag.name}</td>
                <td>
                  {editingId === tag._id ? (
                    <select 
                      value={editData.category} 
                      onChange={e => setEditData({ ...editData, category: e.target.value })}
                    >
                      {categories.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
                    </select>
                  ) : (
                    categories.find(c => c.value === tag.category)?.label || tag.category
                  )}
                </td>
                <td>{tag.usageCount}</td>
                <td>
                  {editingId === tag._id ? (
                    <>
                      <input 
                        type="text" 
                        value={editData.displayName} 
                        onChange={e => setEditData({ ...editData, displayName: e.target.value })}
                        placeholder="Имя"
                      />
                      <input 
                        type="color" 
                        value={editData.color} 
                        onChange={e => setEditData({ ...editData, color: e.target.value })}
                        className="color-input-small"
                      />
                      <button className="btn-sm" onClick={() => saveEdit(tag._id)}>💾</button>
                      <button className="btn-sm" onClick={() => setEditingId(null)}>✕</button>
                    </>
                  ) : (
                    <>
                      <button className="btn-sm" onClick={() => startEdit(tag)}>✏️</button>
                      {!tag.isSystem && (
                        <button className="btn-sm btn-danger" onClick={() => deleteTag(tag._id)}>🗑️</button>
                      )}
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TagsManagement;
